import React from "react";

// Hinweis, wie viele Testkonten/-laeufe aus einer Auswertung herausgefiltert wurden.
export const TestExcludedNote = ({ count, testId = "test-excluded-note" }) => {
  if (count === undefined || count === null) return null;
  return (
    <p className="mt-1 text-xs text-slate-500" data-testid={testId}>
      Nur Echtdaten · {Number(count).toLocaleString("de-DE")} Testkonten/-läufe herausgefiltert
    </p>
  );
};

export default TestExcludedNote;
